import { useEffect } from "react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import BookButton from "@/components/site/BookButton";
import Pillars from "@/components/sections/Pillars";
import CTASection from "@/components/sections/CTASection";
import { PILLAR_IMAGE_LIFESTYLE } from "@/lib/site";

export default function Program() {
    useEffect(() => {
        document.title = "The Program | 90 Day Alpha";
    }, []);

    return (
        <div data-testid="program-page" className="bg-[#020617]">
            <section className="relative pt-40 pb-20 md:pt-48 md:pb-28">
                <div className="absolute inset-0 opacity-40">
                    <img
                        src={PILLAR_IMAGE_LIFESTYLE}
                        alt="90 Day Alpha — The Program"
                        className="w-full h-full object-cover grayscale"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/85 to-[#020617]/50" />
                </div>

                <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                    <Reveal>
                        <SectionLabel testId="program-label">
                            About The Program
                        </SectionLabel>
                        <h1 className="mt-6 font-display font-black text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.98] max-w-4xl">
                            A 90-day standard for the man you intend to{" "}
                            <span className="text-[#D4AF37]">become</span>.
                        </h1>
                        <p className="mt-8 text-white/75 leading-relaxed text-base sm:text-lg max-w-2xl">
                            90 Day Alpha is a private, premium coaching program
                            for men who are done waiting for their dating life
                            to improve on its own. It’s not a course you watch.
                            It’s a transformation you live — with structure,
                            coaching, accountability, and a brotherhood of men
                            walking the same path.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-[#020617] py-20 md:py-28">
                <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <Reveal>
                            <h2 className="font-display font-black text-white text-3xl md:text-4xl tracking-tight leading-tight">
                                What’s <span className="text-[#D4AF37]">included</span>
                            </h2>
                            <p className="mt-4 text-white/65 leading-relaxed">
                                Built like a high-performance training program —
                                not an info product.
                            </p>
                        </Reveal>
                    </div>
                    <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#142142] border border-[#142142]">
                        {[
                            {
                                t: "Weekly 1:1 Coaching",
                                d: "Direct sessions with a senior coach focused on your specific blocks.",
                            },
                            {
                                t: "Group Accountability Calls",
                                d: "Weekly group calls — a brotherhood of men doing the work in parallel.",
                            },
                            {
                                t: "Structured Curriculum",
                                d: "90 days of sequenced training across mindset, attraction, and lifestyle.",
                            },
                            {
                                t: "Field Work & Reps",
                                d: "Real-world challenges so the skills become reflex, not theory.",
                            },
                            {
                                t: "Texting & Dating Reviews",
                                d: "Real-time feedback on conversations, profiles, and date strategy.",
                            },
                            {
                                t: "Lifestyle Standards",
                                d: "Frameworks for fitness, style, presence, and daily discipline.",
                            },
                        ].map((b, i) => (
                            <Reveal key={i} delay={i * 0.05}>
                                <div className="bg-[#020617] p-6 h-full hover:bg-[#060c1e] transition-colors">
                                    <p className="font-display font-bold text-white text-lg">
                                        {b.t}
                                    </p>
                                    <p className="mt-2 text-white/65 leading-relaxed text-sm">
                                        {b.d}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <Pillars />
            <CTASection />
        </div>
    );
}
